// Feature Showcase (FLYR-611) — animate stat dividers in on scroll.
// Self-guarding (no-op when no dividers present), HMR-safe, honors reduced motion
// (when reduced, CSS already draws the divider, so we skip the observer entirely).

function initFeatureShowcase() {
    const dividers = document.querySelectorAll('[data-fs-divider]');
    if (!dividers.length) {
        return () => {};
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return () => {};
    }

    const observer = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    obs.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.4 }
    );

    dividers.forEach((divider) => observer.observe(divider));

    return () => observer.disconnect();
}

let teardown = initFeatureShowcase();

if (import.meta.hot) {
    import.meta.hot.dispose(() => {
        if (typeof teardown === 'function') {
            teardown();
        }
    });
}
